import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { selectRelatedAuthorsForCurrentBib } from 'app/selectors/bibs/EvaluationSelector';
import RelatedAuthors from './RelatedAuthors';

export class RelatedAuthorsContainer extends React.PureComponent {
  render() {
    return <RelatedAuthors {...this.props} />;
  }
}

RelatedAuthorsContainer.propTypes = {
  relatedAuthors: ImmutablePropTypes.list.isRequired
};

const mapStateToProps = state => ({
  relatedAuthors: selectRelatedAuthorsForCurrentBib(state)
});

export default connect(mapStateToProps)(RelatedAuthorsContainer);
